import React, { Component } from 'react';
import { Header, Footer } from '../';
import * as Env from '../../Env'

let axios = require('axios');

export const getLogo = () => {
	const logo = window.localStorage.getItem('logo');
	return logo
}

export const setLogo = (logo) => {
	window.localStorage.setItem('logo', logo);
}

export default class Template extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loaded: false
		};
	}

	componentDidMount() {
		this.fetchAgentData();

		window.addEventListener('storage', () => {
			const user = JSON.parse(localStorage.getItem('agentData'));
			const logo = user && user.data.logo ? Env.url.api_static + user.data.logo : null;
		})
	}

	async fetchAgentData() {
		try {
			const response = await axios.get(Env.url.api_url + 'hotels/users/profile', {
				headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
			});
			localStorage.removeItem('agentData');
			localStorage.setItem('agentData', JSON.stringify(response.data.data));
			const user = response.data.data;
			const logo = user && user.data.logo ? Env.url.api_static + user.data.logo : null;
			setLogo(logo)
			window.dispatchEvent(new Event('storage'));
			this.setState({ loaded: true });
		} catch (error) {
			console.error('Error fetching agent data:', error);
			this.setState({ loaded: true });
		}
	}

	render() {
		return (
			<div>
				<Header />
				<div style={{ marginTop: '30px', marginBottom: '50px' }}>
					{this.props.children}
				</div>
				{this.state.loaded && <Footer />}
			</div>
		);
	}
}